import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ModuleService } from '@modules/application/services/module.service';
import { map } from 'rxjs/operators';
import { FIXED_LOCAL_MODULES, LOCAL_MODULES } from '@modules/application/constants/module.constants';
import { Observable } from 'rxjs';
import { ClubLocalModule } from '@modules/application/application';

@Component({
    selector: 'app-application-lateral-side',
    templateUrl: './application-lateral-side.component.html',
    styleUrls: ['./application-lateral-side.component.scss'],
})
export class ApplicationLateralSideComponent implements OnInit {
    @Input() user: AppUser;
    @Output() closeSession: EventEmitter<any> = new EventEmitter<any>();
    @Output() showResponsiveMenu: EventEmitter<any> = new EventEmitter<any>();
    menusList: any = [];
    profile: any = {};
    navHeight: string;

    availableModules$: Observable<ClubLocalModule[]> = this.moduleService.modules$.pipe(
        map((remoteModules) => {
            const remoteIdentifiers = remoteModules.map((m) => m.identifier);
            const availableModules = LOCAL_MODULES.reduce((acc, localModule) => {
                if (!remoteIdentifiers.includes(localModule.code)) return acc;

                const remoteModule = remoteModules.find((m) => m.identifier === localModule.code);

                return [
                    ...acc,
                    {
                        ...localModule,
                        ...remoteModule,
                    },
                ];
            }, [] as ClubLocalModule[]);
            return FIXED_LOCAL_MODULES.concat(availableModules.sort((a, b) => a.name.localeCompare(b.name)));
        })
    );

    constructor(private moduleService: ModuleService) {}

    ngOnInit() {
        this.getAppHeight();
        this.profile.info = {};
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.getAppHeight();
    }

    getAppHeight() {
        this.navHeight = `${window.innerHeight - 50}px`;
    }
}
